module.exports = __webpack_public_path__ + "static/img/product_images_32_h5_zh.9d8eecf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_32_h5_zh.png
// module id = tRe2
// module chunks = 34